import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  margin: auto;
  align-items: center;
  justify-content: center;

  width: 60%;

  @media (max-width: 600px) {
    width: 95%;
  }
`

export const MessageWrapper = styled.div`
  margin-top: 100px;
  margin-bottom: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
`

export const LoadingSpinner = styled(CircularProgress)`
  margin-right: 15px;
`

export const Text = styled.div`
  text-align: center;
  margin: 12px;
`
